export default function Heatmap({ days = [], bins = [], grid = [] }) {
  const flat = grid.flat();
  const max = Math.max(1, ...flat);

  const colorFor = (v) => {
    if (v === 0) return "#f1f5f9";
    const t = v / max;
    // interpolate: light peach (#fed7aa) -> orange -> red (#7f1d1d)
    const stops = [
      { p: 0, c: [254, 226, 226] }, // #fee2e2
      { p: 0.35, c: [252, 165, 165] }, // #fca5a5
      { p: 0.65, c: [239, 68, 68] }, // #ef4444
      { p: 1, c: [127, 29, 29] }, // #7f1d1d
    ];
    let s = stops[0], e = stops[stops.length - 1];
    for (let i = 0; i < stops.length - 1; i++) {
      if (t >= stops[i].p && t <= stops[i + 1].p) { s = stops[i]; e = stops[i + 1]; break; }
    }
    const local = (t - s.p) / (e.p - s.p || 1);
    const rgb = s.c.map((v, i) => Math.round(v + (e.c[i] - v) * local));
    return `rgb(${rgb.join(",")})`;
  };

  return (
    <div className="w-full">
      <div className="flex">
        <div className="flex flex-col justify-between pr-2 text-[10px] font-semibold text-slate-500 py-1">
          {days.map((d) => <div key={d} className="h-6 flex items-center">{d}</div>)}
        </div>
        <div className="flex-1">
          <div className="grid gap-1" style={{ gridTemplateColumns: `repeat(${bins.length}, minmax(0, 1fr))` }}>
            {grid.map((row, ri) =>
              row.map((v, ci) => (
                <div
                  key={`${ri}-${ci}`}
                  title={`${days[ri]} ${bins[ci]}: ${v} events`}
                  className="h-6 rounded-sm"
                  style={{ background: colorFor(v) }}
                />
              ))
            )}
          </div>
          <div className="grid mt-1.5 text-[9px] text-slate-500 font-medium" style={{ gridTemplateColumns: `repeat(${bins.length}, minmax(0, 1fr))` }}>
            {bins.map((b, i) => (
              <div key={b} className={`text-center ${i % 2 === 0 ? "opacity-100" : "opacity-0"}`}>{b}</div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 justify-end mt-3 text-[10px] text-slate-500">
        <span>Low</span>
        <div className="flex h-2 rounded overflow-hidden w-24">
          {[0, 0.25, 0.5, 0.75, 1].map((t) => (
            <div key={t} className="flex-1" style={{ background: colorFor(t * max) }} />
          ))}
        </div>
        <span>High</span>
      </div>
    </div>
  );
}
